import { Component, Input, OnChanges } from '@angular/core';
import { ModalService } from '@src/shared/modal/modal.service';
import { SimpleChanges } from '../../../utils/types';
import { AdServerService } from '../../../woo_services.module/AdServerService';
import { CampaignService } from '../../../woo_services.module/CampaignService';
import { Campaign } from '../../../woo_services.module/shared-types';

@Component({
  selector: 'frequency-limit',
  templateUrl: './frequency-limit.component.html',
  standalone: false,
})
export class FrequencyLimit implements OnChanges {
  @Input() campaign: Campaign;
  frequencyLimitActive: boolean;

  constructor(
    private adServerService: AdServerService,
    private campaignService: CampaignService,
    private modalService: ModalService,
  ) {}

  ngOnChanges(changes: SimpleChanges<FrequencyLimit>): void {
    if (changes.campaign && this.campaign) {
      this.frequencyLimitActive = this.campaign.default_video_frequency_limit;
    }
  }

  updateCampaignDefaultFrequencyLimit(): void {
    let errorMsg = 'Nu ville det sig inte riktigt. Var god försök igen!';
    const loaderModal = this.modalService.openLoader('Uppdaterar frekvenstaket och skickar till adservern.');
    this.campaignService
      .updateCampaignDefaultFrequencyLimit(this.campaign.id, this.frequencyLimitActive)
      .then(() => {
        errorMsg =
          'Frekvenstaket uppdaterades men kampanjen kunde inte skickas till adservern. Var god försök att skicka till adservern manuellt.';
        return this.adServerService.sendCampaign(this.campaign.id);
      })
      .then(() => {
        this.campaign.default_video_frequency_limit = this.frequencyLimitActive;
        this.modalService.openSuccess('Frekvenstaket uppdaterades.');
      })
      .catch(() => {
        this.modalService.openError('Attans!', errorMsg);
      })
      .finally(() => {
        loaderModal.close();
      });
  }
}
